import React, { useEffect, useState } from 'react';
import { Label, FormGroup, InputGroup, InputGroupAddon, Input, Button, Fade } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Icon from '../../../Icon/Icon';

const NewIFrameConstructorLink = ({ streamLink, width, previewRef }) => {
  const [isCopied, setIsCopied] = useState(false);
  const [previewHeight, setPreviewHeight] = useState('199%');
  const embedLink = `<iframe src="${streamLink.replace('http:', '')}" width="${width.replace(
    'px',
    '',
  )}" height="${previewHeight}" frameborder="0"></iframe>`;

  useEffect(() => {
    const currentHeight = previewRef.current?.offsetHeight;
    if (currentHeight !== previewHeight) setPreviewHeight(currentHeight);
  });

  useEffect(() => {
    isCopied && setTimeout(() => setIsCopied(false), 1200);
  }, [isCopied]);

  const handleCopy = () => {
    setIsCopied(true);
  };

  return (
    <FormGroup>
      <Label>
        {streamLink ? (
          <>
            <FormattedMessage id="iframe_constructor.code.label" defaultMessage="Embed code:" />
            <Fade in={isCopied} tag="span" className="copy-message">
              <FormattedMessage id="flow.copied" defaultMessage="copied to clipboard" />
            </Fade>
          </>
        ) : (
          <FormattedMessage
            id="iframe_constructor.code.empty"
            defaultMessage="Save the flow to get the embed code"
          />
        )}
      </Label>

      {streamLink && (
        <InputGroup>
          <Input className="stream-link" value={embedLink} readOnly />
          <InputGroupAddon addonType="append">
            <CopyToClipboard text={embedLink} onCopy={handleCopy}>
              <Button type="button" color="primary" onClick={() => false}>
                <Icon type="copy" />{' '}
                <FormattedMessage id="flow.form.link.copy" defaultMessage="Copy" />
              </Button>
            </CopyToClipboard>
          </InputGroupAddon>
        </InputGroup>
      )}
    </FormGroup>
  );
};

export { NewIFrameConstructorLink };
